import { getGridStringOperators, getGridDateOperators } from '@mui/x-data-grid';
import { isArray } from 'lodash';
import moment from 'moment';

export const columnsArray = [
  {
    field: 'employeeName',
    headerName: 'Name',
    width: 250,
    type: 'string',
    filterOperators: getGridStringOperators().filter(
      (operator) => !['isEmpty', 'isNotEmpty', 'isAnyOf'].includes(operator.value)
    ),
    sortable: false
  },
  {
    field: 'beneficiaryName',
    headerName: 'Beneficiary',
    width: 250,
    type: 'string',
    filterOperators: getGridStringOperators().filter(
      (operator) => !['isEmpty', 'isNotEmpty', 'isAnyOf'].includes(operator.value)
    )
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 220,
    type: 'singleSelect',
    valueOptions: [
      'PENDING_DR_REVIEW',
      'PENDING_ADMIN_REVIEW',
      'PENDING_FINANCE_REVIEW',
      'APPROVED',
      'DISAPPROVED',
      'OPEN'
    ],
    sortable: false
  },
  {
    field: 'specialization',
    headerName: 'Specialization',
    width: 220,
    type: 'singleSelect',
    valueOptions: []
  },
  {
    field: 'createdAt',
    headerName: 'Creation Date',
    width: 200,
    type: 'date',
    valueFormatter: (params) => {
      return moment(params.value).format('DD MMM YYYY');
    },
    filterOperators: getGridDateOperators().filter(
      (operator) => !['isEmpty', 'isNotEmpty'].includes(operator.value)
    )
  }
];

export const handlePagination = (model, urlParams, setUrlParams) => {
  if (model.pageSize !== Number(urlParams.get('take') || 10)) {
    urlParams.set('skip', 0);
    urlParams.set('take', model.pageSize || 10);
  } else {
    urlParams.set('skip', model.page * model.pageSize);
  }
  setUrlParams(urlParams);
};

export const handleSort = (model, urlParams, setUrlParams) => {
  if (model.length > 0) {
    if (urlParams.get('sortColumn') === model[0].field && urlParams.get('sort') === model[0].sort)
      return;
    urlParams.set('skip', 0);
    urlParams.set('sortColumn', model[0].field);
    urlParams.set('sort', model[0].sort);
  } else {
    urlParams.set('skip', 0);
    urlParams.delete('sortColumn');
    urlParams.delete('sort');
  }
  setUrlParams(urlParams);
};

export const handleFilter = (model, urlParams, setUrlParams, prevModel, setPrevModel) => {
  if (JSON.stringify(prevModel) === JSON.stringify(model)) return;
  urlParams.set('skip', 0);
  console.log(model);
  if (model?.items?.length > 0) {
    urlParams.set('filterColumn', model.items[0].field);
    urlParams.set('filterOperation', model.items[0].operator);
    if (isArray(model.items[0].value)) {
      if (model.items[0].value.length > 0) {
        urlParams.set('filterValue', model.items[0].value.join(','));
      } else {
        urlParams.delete('filterValue');
      }
    } else if (model.items[0].value) {
      urlParams.set('filterValue', model.items[0].value);
    } else {
      urlParams.delete('filterValue');
    }
  } else {
    urlParams.delete('filterColumn');
    urlParams.delete('filterOperation');
    urlParams.delete('filterValue');
    urlParams.delete('filterValues');
  }
  setPrevModel(model);
  setUrlParams(urlParams);
};

export const getFilterModel = (urlParams) => {
  return {
    items: urlParams.get('filterColumn')
      ? [
          {
            field: urlParams.get('filterColumn'),
            operator: urlParams.get('filterOperation'),
            value: urlParams.get('filterValue')
              ? urlParams.get('filterOperation') === 'isAnyOf'
                ? urlParams.get('filterValue').split(',')
                : urlParams.get('filterValue')
              : undefined
          }
        ]
      : [],
    linkOperator: 'and'
  };
};

export const getSortModel = (urlParams) => {
  return urlParams.get('sortColumn')
    ? [{ field: urlParams.get('sortColumn'), sort: urlParams.get('sort') }]
    : [];
};

export const getPaginationModel = (urlParams) => {
  return {
    page: Number(urlParams.get('skip') || 0) / Number(urlParams.get('take') || 10),
    pageSize: Number(urlParams.get('take') || 10)
  };
};
